import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { CheckboxPanels } from '@eika/checkbox';
import { ExpandableInput } from '@eika/expandable-input';

import { Laaneformaal } from '../../generated-types';
import { useTranslation } from '../../translations';
import { LaanebeloepFormData } from '../laan/laanebeloep';

export type BoligverdiLaaneformaalFormData = {
    laaneformaal: Laaneformaal[] | null;
    annetLaaneformaal: string | null;
};

const BoligverdiLaaneformaal: FC = () => {
    const { validationMessage, laanebeloep } = useTranslation();
    const { control, watch } = useFormContext<BoligverdiLaaneformaalFormData>();

    const {
        formState: { errors },
    } = useFormContext<LaanebeloepFormData>();

    const { laaneformaal } = watch();

    const options: { label: string; value: Laaneformaal }[] = [
        { label: laanebeloep.formaalOppussing, value: Laaneformaal.OPPUSSING },
        { label: laanebeloep.formaalByggeBolig, value: Laaneformaal.BYGGE_PAA_BOLIG },
        { label: laanebeloep.formaalKjoepeBil, value: Laaneformaal.KJOEPE_BIL },
        { label: laanebeloep.formaalInnfriGjeld, value: Laaneformaal.INNFRI_GJELD },
        { label: laanebeloep.formaalAnnet, value: Laaneformaal.ANNET },
    ];

    return (
        <>
            <Controller
                name="laaneformaal"
                control={control}
                rules={{
                    required: `${validationMessage.requiredValue}`,
                }}
                render={({ field }) => {
                    const fieldValue = field.value || [];
                    return (
                        <CheckboxPanels
                            label={laanebeloep.formaal}
                            error={errors.laaneformaal?.message}
                            options={options.map((option) => ({
                                label: option.label,
                                value: option.value.toString(),
                                checked: fieldValue.includes(option.value),
                                onValueChange: (checked) => {
                                    const newValue = checked
                                        ? [...fieldValue, option.value]
                                        : fieldValue.filter((val) => val !== option.value);
                                    field.onChange(newValue);
                                },
                            }))}
                        />
                    );
                }}
            />
            {laaneformaal?.includes(Laaneformaal.ANNET) && (
                <Controller
                    name="annetLaaneformaal"
                    control={control}
                    rules={{
                        required: `${validationMessage.requiredValue}`,
                    }}
                    render={({ field }) => (
                        <ExpandableInput
                            label={laanebeloep.formaalAnnetTitle}
                            error={errors.annetLaaneformaal?.message}
                            maxLength={200}
                            value={field.value ?? ''}
                            onChange={field.onChange}
                            showCharCounter
                        />
                    )}
                />
            )}
        </>
    );
};

export default BoligverdiLaaneformaal;
